module.exports = __webpack_public_path__ + "static/img/carousel_1_quelbo_ar_16_9_w_768.f830626.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_1_quelbo_ar_16_9_w_768.jpg
// module id = bkG8
// module chunks = 0